<template>
  <div
    class="page-header clear-filter"
    style="background-image: url('img/ship.jpg'); background-size: cover"
    filter-color="red"
  >
    <div class="page-header-image"></div>
    <div class="content">
      <div class="container">
        <div class="col-md-12">
          <Toast position="bottom-right" :baseZIndex="2222" />
        </div>          
        <div class="col-md-5 ml-auto mr-auto">
          <h2>Members only</h2>
          <form
            v-if="!forgot_password && user_is_confirmed"
            @submit.prevent="signIn"
          >
            <card type="login" plain>
              <div slot="header"></div>

              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="Email"
                v-model="login_model.email"
                id="email"
              ></fg-input>

              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons text_caps-small"
                placeholder="Password"
                v-model="login_model.password"
                type="password"
                id="password"
              ></fg-input>

              <div slot="raw-content">
                <button
                  v-if="!loading"
                  type="submit"
                  name="button"
                  class="btn btn-info btn-round btn-lg btn-block"
                >
                  Login
                </button>
                <div class="col-md-12" v-else>
                  <ProgressBar mode="indeterminate" />
                </div>
                <a href="#" style="color: white" @click="forgotPassword"
                  >I forgot the password</a
                >
              </div>
            </card>
          </form>
          <form
            v-if="!forgot_password && !user_is_confirmed"
            @submit.prevent="confirmSignUp"
          >
            <card type="login" plain>
              <div slot="header"></div>

              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="Email"
                v-model="confirm_sing_up_email"
                id="confirm_sing_up_email"
                disabled
              ></fg-input>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="Verification Code"
                v-model="confirm_sing_up_code"
                id="confirm_sing_up_code"
              ></fg-input>

              <div slot="raw-content">
                <button
                  v-if="!loading"
                  type="submit"
                  name="button"
                  class="btn btn-info btn-round btn-lg btn-block"
                >
                  Confirm Code
                </button>
                <div class="col-md-12" v-else>
                  <ProgressBar mode="indeterminate" />
                </div>
                <a href="#" style="color: white" @click="returnSignIn"
                  >Login</a
                >
              </div>
            </card>
          </form>
          <form
            v-if="forgot_password && !recovery_code_sended"
            @submit.prevent="sendRecoveryCode"
          >
            <card type="sendRecoveryCode" plain>
              <div slot="header"></div>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="Email"
                v-model="recovery_email"
                id="recovery_email"
              ></fg-input>
              <div slot="raw-content">
                <button
                  v-if="!loading"
                  type="submit"
                  name="button"
                  class="btn btn-info btn-round btn-lg btn-block"
                >
                  Send Verification Code
                </button>
                <div class="col-md-12" v-else>
                  <ProgressBar mode="indeterminate" />
                </div>
                <a href="#" style="color: white" @click="returnSignIn"
                  >Login</a
                >
              </div>
            </card>
          </form>
          <form
            v-if="forgot_password && recovery_code_sended"
            @submit.prevent="sendNewPassword"
          >
            <card type="sendNewPassword" plain>
              <div slot="header"></div>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="New Password"
                v-model="recovery_new_password"
                id="recovery_new_password"
              ></fg-input>

              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="Verification Code"
                v-model="recovery_code"
                id="recovery_code"
              ></fg-input>
              <div slot="raw-content">
                <button
                  type="submit"
                  name="button"
                  class="btn btn-info btn-round btn-lg btn-block"
                  v-if="!loading"
                >
                  Cambiar Contraseña
                </button>
                <div class="col-md-12" v-else>
                  <ProgressBar mode="indeterminate" />
                </div>
                <a href="#" style="color: white" @click="returnSignIn"
                  >Login</a
                >
              </div>
            </card>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput, Alert, Modal } from "@/components";
import { Auth } from "aws-amplify";
import Toast from "primevue/toast";
import ProgressBar from "primevue/progressbar";

class Login {
  constructor(email, password) {
    this.email = email;
    this.password = password;
  }
}
export default {
  name: "login-page",
  bodyClass: "login-page",

  data() {
    return {
      login_model: new Login(),
      forgot_password: false,
      recovery_code_sended: false,
      email: "",
      recovery_email: "",
      recovery_new_password: "",
      recovery_code: "",
      loading: false,
      user_is_confirmed: true,
      confirm_sing_up_code: "",
      confirm_sing_up_email: "",
      //////////////////////////
      password: "",
      login: [],
      message: "",
      error: false,
      new_email: "",
      new_pass: "",
    };
  },
  created() {},
  methods: {
    returnSignIn() {
      this.recovery_code_sended = false;
      this.forgot_password = false;
      this.user_is_confirmed = true;
    },
    forgotPassword() {
      this.forgot_password = true;
    },
    async signIn() {
      this.loading = true;
      try {
        const user = await Auth.signIn(
          this.login_model.email,
          this.login_model.password
        );
        Auth.currentSession()
          .then((data) => {
            localStorage.setItem("idToken", data["idToken"]["jwtToken"]);
            this.$router.replace({ name: "Dashboard" }).catch((err) => {});
          })
          .catch((err) => {
            // console.log(err);
          });
      } catch (error) {
        if (error.code == "UserNotConfirmedException") {
          this.user_is_confirmed = false;
          this.signInResendConfirmationCode(this.login_model.email);
        } else {
          this.message = error["message"];
          this.$toast.add({
            severity: "error",
            summary: "Error Message",
            detail: this.message,
            life: 5000,
          });
        }

        // console.log("error signing in", error);
      } finally {
        this.loading = false;
      }
    },
    sendRecoveryCode() {
      this.loading = true;
      // Send confirmation code to user's email
      Auth.forgotPassword(this.recovery_email)
        .then((data) => {
          this.recovery_code_sended = true;

          this.message = "Confirmation Code has been sent";
          this.$toast.add({
            severity: "success",
            summary: "Success Message",
            detail: this.message,
            life: 5000,
          });
        })
        .catch((err) => {
          // console.log(err);
          this.message = err["message"];

          this.$toast.add({
            severity: "error",
            summary: "Error Message",
            detail: this.message,
            life: 5000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendNewPassword() {
      // Collect confirmation code and new password, then
      Auth.forgotPasswordSubmit(
        this.recovery_email,
        this.recovery_code,
        this.recovery_new_password
      )
        .then((data) => {
          this.recovery_code_sended = false;
          this.forgot_password = false;
        })
        .catch((err) => {
          // console.log(err);
          this.message = err["message"];
          this.$toast.add({
            severity: "error",
            summary: "Error Message",
            detail: this.message,
            life: 5000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUser() {
      Auth.currentAuthenticatedUser({
        bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then((user) => {
          // console.log(user);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getSession() {
      Auth.currentSession()
        .then((data) => {
          localStorage.setItem("idToken", data["idToken"]["jwtToken"]);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async signInResendConfirmationCode(email) {
      try {
        await Auth.resendSignUp(email);
        this.confirm_sing_up_email = email;
        // console.log("code resent successfully");

        this.message = "Confirmation Code has been sent";
        this.$toast.add({
          severity: "success",
          summary: "Success Message",
          detail: this.message,
          life: 5000,
        });
      } catch (err) {
        // console.log("error resending code: ", err);
        this.message = err["message"];
        this.$toast.add({
          severity: "error",
          summary: "Error Message",
          detail: this.message,
          life: 5000,
        });
      }
    },
    async confirmSignUp() {
      try {
        await Auth.confirmSignUp(
          this.confirm_sing_up_email,
          this.confirm_sing_up_code
        );
        this.returnSignIn();
      } catch (err) {
        // console.log("error confirming sign up", err);
        this.message = err["message"];
        this.$toast.add({
          severity: "error",
          summary: "Error Message",
          detail: this.message,
          life: 5000,
        });
      }
    },
    messageClose() {
      this.message = "";
    },
  },
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    Alert,
    Modal,
    Toast,
    ProgressBar,
  },
};
</script>